{
  "version": 1,
  "asset_id": "db0dc6b6-d2cd-4759-a599-c73fa4754fec",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/db0dc6b6-d2cd-4759-a599-c73fa4754fec/hiatal-type-2-sleeve-en-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/db0dc6b6-d2cd-4759-a599-c73fa4754fec/hiatal-type-2-sleeve-en-800.webp",
  "original_filename": "hiatal-type-2-sleeve-en-800.webp",
  "size": 42140,
  "content_type": "image/webp",
  "created_at": "2026-09-26T22:45:47Z"
}
